const state = {
	mainContainer: null,
	socketTimestamp: new Date().getTime(),
	websocketMessage: '',
	online: false,
	appShow:false,
	formShow:false,
	user: null,
	systemdata:null,
	nav: [],
	carmera:null,
	formMap: {
		flow: 'components/forms/form/flow/form.vue',
		relation: 'components/forms/form/relation/form.vue'
	},
	//windowConfig: 'toolbar=no,resizable=yes,width=' + screen.availWidth + ',height=' + screen.availHeight,
	// windowConfig:'toolbar=no,resizable=yes,width='+(Math.min(screen.availWidth,2000))+',height='+Math.min(screen.availHeight,800),
	windowConfig: 'toolbar=no,resizable=yes,width=1800,height=1000',
	onlinelist: {},
	toolbarButtonList: [
		// 	{
		// 	code: 'reload',
		// 	circle: true,
		// 	name: '刷新',
		// 	icon: 'vxe-icon-refresh',
		// 	// type:'text',
		// 	status: '',
		// 	tools: true
		// }, 
		{
			code: 'add',
			name: '新建',
			// type:'text',
			// icon: 'vxe-icon-edit',
			status: 'primary',
		}, {
			code: 'buttonauth',
			name: '其他按钮权限',
			// type:'text',
			status: '',
		}, {
			code: 'error',
			name: '异常',
			// type:'text',
			// icon: 'vxe-icon-edit',
			status: 'danger',
		}, {
			code: 'batchadd',
			name: '批量新建',
			// type:'text',
			// icon: 'vxe-icon-edit',
			status: 'warning',
			group: {
				name: '批量操作',
				status: ''
			}
		}, {
			code: 'batchupload',
			name: '批量上传',
			// type:'text',
			// icon: 'vxe-icon-edit',
			status: 'danger',
			// group: {
			// 	name: '批量操作',
			// 	status: ''
			// }
		}, {
			code: 'batchdelete',
			name: '批量删除',
			// type:'text',
			// icon: 'vxe-icon-edit',
			status: 'danger',
			group: {
				name: '批量操作',
				status: ''
			}
		},{
			code: 'batchreaudit',
			name: '批量审核',
			// type:'text',
			// status: 'primary',
			status: 'danger',
			group: {
				name: '批量操作',
				status: ''
			}
		}, {
			code: 'importpanel',
			name: '导入面板',
			// type:'text',
			// icon: 'vxe-icon-edit',
			status: 'warning',
		}, {
			code: 'import',
			name: '导入',
			// type:'text',
			status: 'success',
			// group: {
			// 	name: '导入',
			// 	status: 'success'
			// }
		}, {
			code: 'importtemplate',
			name: '导入模板',
			// type:'text',
			status: 'info',
			group: {
				name: '导入',
				status: 'success'
			}
		}, {
			code: 'export',
			name: '导出',
			// type:'text',
			status: 'success',
		}, {
			code: 'exportpanel',
			name: '导出面板',
			// type:'text',
			status: 'danger',
		}, {
			code: 'exportcurrent',
			name: '导出当前',
			// type:'text',
			status: 'danger',
		}, {
			code: 'exportall',
			name: '导出全部',
			// type:'text',
			status: 'danger',
		}, {
			code: 'exportdetail',
			name: '导出明细',
			// type:'text',
			status: 'primary',
		}, {
			code: 'batchsonflow',
			name: '批量发起子流程',
			// type:'text',
			status: 'danger',
		}, {
			code: 'download',
			name: '下载',
			// type:'text',
			status: 'danger',
		}, {
			code: 'importtask',
			name: '导入任务',
			// type:'text',
			status: 'danger',
		}

	],


	operateButtonList: [{
		code: 'preview',
		content: '预览',
		status: 'primary',
		icon: 'vxe-icon-edit',
	}, {
		code: 'add',
		content: '新建',
		status: 'success',
		icon: 'vxe-icon-add',
		inrow: true,
	}, {
		code: 'edit',
		content: '编辑',
		status: 'primary',
		icon: 'vxe-icon-edit',
		inrow: true,
	}, {
		code: 'copy',
		content: '复制',
		status: 'danger',
		icon: 'vxe-icon-copy',
	}, {
		code: 'print',
		content: '打印',
		status: 'danger',
		icon: 'vxe-icon-copy',
		inrow: true,
	}, {
		code: 'del',
		content: '删除',
		status: 'danger',
		icon: 'vxe-icon-delete',
	}, {
		code: 'controll',
		content: '操作',
		status: 'success',
		icon: 'vxe-icon-setting',
		inrow: true,
	}, {
		code: 'auth',
		content: '权限',
		status: 'success',
		icon: 'vxe-icon-setting',
		inrow: true,
	}, {
		code: 'flow',
		content: '流程',
		status: 'danger',
		icon: 'vxe-icon-swap',
		inrow: true,
	}, {
		code: 'sonflow',
		content: '子流程',
		status: 'danger',
		icon: 'vxe-icon-setting',
		inrow: false,
	}, {
		code: 'reaudit',
		content: '审核',
		status: 'danger',
		icon: 'vxe-icon-swap',
		inrow: false,
	}, {
		code: 'unaudit',
		content: '反审',
		status: 'danger',
		icon: 'vxe-icon-swap',
		inrow: false,
	}, {
		code: 'resetpassword',
		content: '重置密码',
		status: 'danger',
		icon: 'vxe-icon-swap',
		inrow: false,
	}, {
		code: 'cancel',
		content: '撤销',
		status: '',
		icon: 'vxe-icon-swap',
		inrow: true,
	}, {
		code: 'workorder',
		content: '工单	',
		status: 'success',
		icon: 'vxe-icon-feedback',
		inrow: true,
	}, {
		code: 'upload',
		content: '上传	',
		status: 'danger',
		icon: 'vxe-icon-swap',
		inrow: true,
	}, {
		code: 'close',
		content: '关闭',
		status: 'danger',
		icon: 'vxe-icon-setting',
		inrow: false,
	}, {
		code: 'adddinggroup',
		content: '创建钉钉群',
		status: 'danger',
		icon: 'vxe-icon-setting',
		inrow: false,
	}, {
		code: 'updatedinggroup',
		content: '更新钉钉群',
		status: 'danger',
		icon: 'vxe-icon-setting',
		inrow: false,
	}, {
		code: 'config',
		content: '配置',
		status: 'warning',
		icon: 'vxe-icon-setting',
		inrow: true,
	}  ],


	tableoOperateButtons: [{
		code: 'copy',
		name: '复制',
		status: 'success',
		inrow: true
	}]
}
const mutations = {
	setUser(state, payload) {
		state.user = payload
	},
	setSystemdata(state, payload) {
		state.systemdata = payload
	},
	setAppshow(state, payload) {
		state.appShow = payload
	},
	setFormshow(state, payload) {
		state.formShow = payload
	},
	setNav(state, payload) {
		state.nav = payload
	},
	setSocketMessage(state, payload) {
		state.socketTimestamp = new Date().getTime()
		state.websocketMessage = payload
	},
	setOnline(state, payload) {
		state.online = payload
	},
	setOnlineList(state, payload) {
		state.onlinelist = payload
	},
	setMainContainer(state, payload) {
		state.mainContainer = payload.value
	},
	initSystemdata(state) {
		if(!state.systemdata){
			return
		}
		let data = state.systemdata
		for (let i in data) {
			if (i == 'EmunValue') {
				const getEmun = function(name) {
					let options = {}
					let data = []
					window.systemData.emun.forEach((item) => {
						if (item.field === name) {
							data.push(JSON.parse(JSON.stringify(item)))
						}
					})
					options.sourceData = data
					options.options = createTree(JSON.parse(JSON.stringify(data)))
					return options
				}
				const createTree = function(data) {
					let root = []
					data.forEach((item) => {
						item.disabled = item.enable == 5 ? false : true
						if (!item.parentid || item.parentid <= 0) {
							root.push(item)
						}
						data.forEach((_item) => {
							if (_item.parentid === item.id) {
								if (!item.children) {
									item.children = []
								}
								item.children.push(_item)
							}
		
						})
					})
					return root
				}
		
				window.systemData.emun = data[i]
				data[i].forEach((item) => {
		
					if (!window.systemData.options) {
						window.systemData.options = {}
					}
					if (!window.systemData.options[item.field]) {
						window.systemData.options[item.field] = getEmun(item.field)
					}
				})
				window.systemMethods.getEmunLabelByValue = (value) => {
					let label = null
					window.systemData.emun.forEach((item) => {
						if (item.id === value) {
							label = item.label
						}
					})
					return label
				}
				//console.log(window.systemData.options)
				
				window.systemMethods.getEmunValue = (field, value) => {
					if (!value) {
						return ''
					}
					if (Array.isArray(value)) {
						let text = []
						value.forEach((val) => {
							let itemid = val
							if(Array.isArray(itemid)){
								itemid = itemid[itemid.length-1]
							}
							let index = data[i].findIndex((item) => {
								return item.field == field && item.value == itemid
							})
							if (index !== -1) {
								text.push(data[i][index].label)
							} else {
								text.push('')
							}
						})
						return text.join('/')
					} else {
						let index = data[i].findIndex((item) => {
							return item.field == field && item.value == value
						})
						if (index !== -1) {
							return data[i][index].label
						} else {
							return ''
						}
					}
				}
				
				window.systemMethods.getEmunId = (field, label) => {
					let buff = true
					let value = []
					if (!label) {
						return null
					}
					
					let splitlabel = label.split('/')
					for(let i = 0; i < splitlabel.length; i++){
						let obj = window.systemData.emun.find((item) => {
							return item.field == field && item.label == splitlabel[i].trim()
						})
						if(obj){
							value.push(obj.value)
						}else{
							buff = false
							break
						}
					}				
					if(buff){
						return value.length==1?value[0]:value
					}					
					return null
				}
				window.systemMethods.getEmunCodeByValue = (value) => {
					let code = null
					window.systemData.emun.forEach((item) => {
						if (item.id === value) {
							code = item.code
						}
					})
					return code
				}		
			} else {
				window.systemData[i] = data[i]
				window.systemMethods['get' + i] = (value,type='id') => {
					//console.log(i,value,data[i])
					let result = []
					if (Array.isArray(value)) {
						value.forEach((v) => {
							let index = data[i].findIndex((item) => {
								if(type=='id'){
									return item.id == v
								}else{
									return item.name == v.trim()
								}								
							})
							if (index !== -1) {
								if(type=='id'){
									result.push(data[i][index].name)
								}else{
									result.push(parseInt(data[i][index].id))
								}
								
							}
						})
					} else {
						let index = data[i].findIndex((item) => {
							if(type=='id'){
								return item.id == value
							}else{
								return item.name == value.trim()
							}
						})
						if (index !== -1) {
							if(type=='id'){
								result.push(data[i][index].name)
							}else{
								result.push(parseInt(data[i][index].id))
							}
						}
					}
					if(type=='id'){
						return result.join(',')
					}else{
						return result[0]
					}
					
				}
			}
		}
	},
}
export default {
	namespaced: true,
	state,
	mutations,
}